import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import logo from './img/logo.webp';
import FadeIn from 'react-fade-in';

export default function Navbar(): ReactElement {
    const history = useHistory();

    return (
        <div className='nav'>
            <img
                alt='TABULA'
                src={logo}
                className='logo'
                onClick={ () => history.push('/') }
            />
        </div>
    );
}
